import {
  AbstractControl,
  AbstractControlOptions,
  AsyncValidatorFn, FormArray,
  FormControl,
  FormGroup,
  ValidatorFn, Validators
} from '@angular/forms';
import { environment } from '../../../environments/environment';
import { IDayCalendarConfig } from 'ng2-date-picker';

export class AppForm extends FormGroup {
  public specialChars = environment.specialChars;
  public numbers = environment.numbers.join('');

  public calendarConfig: IDayCalendarConfig = {
    firstDayOfWeek: 'mo',
    format: 'DD.MM.YYYY'
  };

  constructor(
    controls: {
      [key: string]: AbstractControl;
    },
    validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null,
    asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null
  ) {
    super(controls, validatorOrOpts, asyncValidator);
  }

  public patchFormValues(value: any): void {
    super.patchValue(value);
  }

  public showError(controlName: string): boolean {
    const ctrl = this.get(controlName);
    return !!ctrl?.invalid && !!ctrl?.touched;
  }

  public getElement(e: Event): HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement {
    return e.target as HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement;
  }

  public getFormControlByName(name: string): FormControl | null {
    return this.get(name) as FormControl | null;
  }

  public getFormGroupByName(name: string): FormGroup | null {
    return this.get(name) as FormGroup;
  }

  public getFormArrayByName(name: string): FormArray | null {
    return this.get(name) as FormArray;
  }
}
